import { View } from 'react-native';
import { cn } from '@/lib/utils';
import { Text } from '@/components/ui/text';
import { Input } from '@/components/ui/input';

interface MacroCardProps {
  label: string;
  /** Full literal background class for the colour dot (e.g. "bg-macro-protein"). */
  dotClass: string;
  value: string;
  onChangeText: (text: string) => void;
  onBlur?: () => void;
  hasError?: boolean;
}

/**
 * One macro tile in the 2x2 nutrition grid: a coloured dot + label and an
 * editable gram value with a trailing "g" unit.
 */
export const MacroCard = ({
  label,
  dotClass,
  value,
  onChangeText,
  onBlur,
  hasError,
}: MacroCardProps) => {
  return (
    <View
      className={cn(
        'flex-1 gap-1 rounded-2xl bg-surface p-4',
        hasError && 'border border-destructive',
      )}
    >
      <View className="flex-row items-center gap-2">
        <View className={cn('h-2.5 w-2.5 rounded-full', dotClass)} />
        <Text className="text-sm text-text-secondary">{label}</Text>
      </View>
      <View className="flex-row items-end gap-1">
        <Input
          keyboardType="numeric"
          value={value}
          onChangeText={onChangeText}
          onBlur={onBlur}
          className="flex-1 border-0 bg-transparent px-0 text-2xl font-sora-semibold text-text-primary"
          placeholder="0"
        />
        <Text className="pb-2 text-sm text-text-muted">g</Text>
      </View>
    </View>
  );
};
